import angular from 'angular';
import templateUrl from "./rogers-slippage-summary-report.component.html";
import { containsInvariant } from '../../../core/services/filter-util';

export const RogersSlippageSummaryReportComponent = {
    templateUrl,
    bindings: {
        slippageSummaryReport: "<"
    },
    controller: class {
        constructor() {
            'ngInject'
            this.pageNumber = 1;
            this.pageSize = 50;
            this.filters = {};
        }

        $onInit() {
        }

        $onChanges(changes) {
            if (changes.slippageSummaryReport && changes.slippageSummaryReport.currentValue) {
                this.filteredReport = changes.slippageSummaryReport.currentValue.filter(p => this.filterReport(p));
                this.summaryTotals = this.aggregateTotals(this.slippageSummaryReport);
            }
        }

        onChangeFilter() {
            this.pageNumber = 1;
            this.filteredReport = angular.copy(this.slippageSummaryReport);
            this.filteredReport = this.slippageSummaryReport.filter(p => this.filterReport(p));
        }

        filterReport(data) {
            return !this.filters.OwnerName || containsInvariant(data.Owner, this.filters.OwnerName);
        }

        aggregateTotals(report) {
            const totals = {
                BookingCount: 0,
                ConfirmedCount: 0,
                PendingInstallCount: 0,
                CancelledCount: 0,
                Slippage: 0,
                SlippagePercentage: null
            }
            report.reduce((totals, owner) => {
                totals.BookingCount += owner.BookingCount || 0;
                totals.ConfirmedCount += owner.ConfirmedCount || 0;
                totals.PendingInstallCount += owner.PendingInstallCount || 0;
                totals.CancelledCount += owner.CancelledCount || 0;
                totals.Slippage += owner.Slippage || 0;
                return totals;
            }, totals);
            // Slippage percentage is an average.
            totals.SlippagePercentage = totals.BookingCount ? (totals.Slippage + totals.CancelledCount) /
                totals.BookingCount : null;
            return totals;
        }
    }
}

